<section class="contact-page">
  <div class="contact-hero">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1>Contact Us</h1>
      <p>Reach out to Econet Wireless Zimbabwe for support, questions, and service assistance.</p>
    </div>
  </div>

  <div class="contact-content">
    <article class="contact-card">
      <h2>Get In Touch</h2>
      <p>
        Our team is available to help with product questions, account support and general enquiries.
      </p>

      <div class="contact-info-grid">
        <div class="info-item">
          <h3>Email</h3>
          <p><a href="mailto:enquiries@econet.co.zw">enquiries@econet.co.zw</a></p>
        </div>

        <div class="info-item">
          <h3>Address</h3>
          <p>Econet Park, No. 2 Old Mutare Road, Msasa, Harare, Zimbabwe</p>
        </div>
      </div>

      <div class="contact-actions">
        <a href="mailto:enquiries@econet.co.zw" class="contact-btn">Email Us</a>
        <a routerLink="/support" class="contact-btn alt">Visit Support</a>
      </div>
    </article>
  </div>
</section>
